import { Component } from '@angular/core';
import { HelpConstant } from './help.constant';
import { Subscription } from 'rxjs';
import { IHelp } from 'src/app/common/model/support.model';

@Component({
  selector: 'app-help',
  templateUrl: './help.component.html',
  styleUrls: ['./help.component.scss']
})
export class HelpComponent {
  subscription = new Subscription();
  helpItems: IHelp[] = HelpConstant;

  constructor() {}
}
